<template>
    <div class="container home">
        <div class="d_table h_100 h_100_important">
            <div class="d_table_cell">
                <img src="../assets/images/guco-home.png" alt="Logo Guco" class="img-responsive m_0_auto">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Home',
    }
</script>



// WEBPACK FOOTER //
// Home.vue?61c60f02